var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { ChoiceOptionState } from '../../../../classes/learnware/LearnwareEnums';
let AbfragerCorrectWrongButtonIcon = class AbfragerCorrectWrongButtonIcon extends React.PureComponent {
    get option() {
        return this.props.option;
    }
    get app() {
        return this.option.context.app;
    }
    get icon() {
        if (this.option.shuffledOptionIndex === 1) {
            return 'fas fa-times';
        }
        return 'fas fa-check';
    }
    get iconColor() {
        if (this.option.optionUI.choiceOptionUIState === ChoiceOptionState.Default) {
            if (this.option.shuffledOptionIndex === 0) {
                return '#5f7927';
            }
            return '#9d2020';
        }
        if ([ChoiceOptionState.CorrectDone, ChoiceOptionState.CorrectPending, ChoiceOptionState.ShouldHaveBeenSelected].includes(this.option.optionUI.choiceOptionUIState)) {
            return '#FFF';
        }
        return '#333';
    }
    render() {
        const { option } = this.props;
        return React.createElement("i", { className: this.icon, style: { color: this.iconColor, marginRight: 15 } });
    }
};
AbfragerCorrectWrongButtonIcon = __decorate([
    observer
], AbfragerCorrectWrongButtonIcon);
export { AbfragerCorrectWrongButtonIcon };
